import { StoreType } from 'types'
import { create } from 'zustand'

type StateType = {
  machineInfor: StoreType['machine_info'] | null
}

type ActionType = {
  setMachineInfor: (machineInfor: StoreType['machine_info']) => void
}

export const useMachineInfor = create<StateType & ActionType>(set => ({
  machineInfor: null,
  setMachineInfor: (machineInfor: StoreType['machine_info']) =>
    set({ machineInfor }),
}))
